<template>
    <div>
        <div class="input-part">
            <div class="input-label">
                <span tkey="地區">{{i18n.tkey("lang_area_text")}}</span>
            </div>

            <div>
                <countrySelector v-model="dataObj.CountryCode" ref="countrySelecterDom" />
            </div>
        </div>

        <div class="input-part">
            <div class="input-label">
                <span tkey="最低購買量">{{i18n.tkey("lang_min_buy_qty")}}</span>
            </div>

            <div>
                <el-input
                        type="number"
                        v-model="dataObj.PriceFrom"
                        placeholder=""
                        clearable
                        min="0"
                />
            </div>
        </div>

        <div class="input-part">
            <div class="input-label">
                <span tkey="運費">{{i18n.tkey("lang_d_cost")}}</span>
            </div>

            <div>
                <el-input
                        type="number"
                        v-model="dataObj.DeliveryFee"
                        placeholder=""
                        clearable
                        min="0"
                />
            </div>
        </div>

        <div>
            <el-button type="primary" @click="clickAddBtn" v-if="null == editObj" tkey="添加">{{i18n.tkey("lang_add_region_setting")}}</el-button>
            <el-button type="primary" @click="clickSaveBtn" v-if="null != editObj" tkey="保存">{{i18n.tkey("lang_save_region_setting")}}</el-button>
        </div>

    </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, onMounted, watch} from "vue";
    import countrySelector from "@/components/shopopee/country/countrySelector"
    import myUtil from "@/util/util";

    const props = defineProps(['editObj'])
    const emits = defineEmits(['clickAdd', 'clickEdit'])

    const i18n = inject("i18n")

    const dataObj = ref({
        CountryCode: null,
        DeliveryFee: 0,
        PriceFrom: 0,
    })

    const countrySelecterDom = ref(null)

    function clickAddBtn() {
        if (myUtil.isEmpty(dataObj.value.CountryCode)){
            myUtil.alertWarning(i18n.tkey("lang_pls_select_region"))
            return
        }

        const obj = generateSettingObj()
        obj.viewId = new Date().getTime() + "" + Math.floor(Math.random() * 1000)

        emits("clickAdd", obj)
    }

    function clickSaveBtn(){
        if (myUtil.isEmpty(dataObj.value.CountryCode)){
            myUtil.alertWarning(i18n.tkey("lang_pls_select_region"))
            return
        }

        const regionObj = countrySelecterDom.value.getSelectObj()
        dataObj.value.CountryName = regionObj.countryname
        dataObj.value.CountryName2 = regionObj.countryname2

        emits("clickEdit", dataObj.value)
    }

    function generateSettingObj(){
        const regionObj = countrySelecterDom.value.getSelectObj()

        return {
            CompanyCode: null,  //eshopopee公司代码
            DeliveryCode: "De7",
            CountryCode: regionObj.countrycode, //地区代码
            Unit: regionObj.currcode, //货币单位
            Curr: regionObj.currcode, //货币单位
            DeliveryFee: dataObj.value.DeliveryFee, //运费
            PriceFrom: dataObj.value.PriceFrom,
            CountryName: regionObj.countryname,
            CountryName2: regionObj.countryname2
        }
    }

    onBeforeMount(() => {

        if (null != props.editObj){
            dataObj.value = props.editObj
        }

    })

</script>

<style scoped>
    .input-part {
        margin-bottom: 20px;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }
</style>